import api from "./api";
import axios from 'axios'

import { ItemsType } from "../components/Inventory/itemsType";
export type DeletItemsDto = {
  id: number | string;
};
export const getItems = async () => {
  return await api.get("/items");
};

export const getItemsDropDown = async (categoryId: number) => {
  return await api.get(`/items/dropdown/${categoryId}`);
};

export const getItemsDropDownSearch = async (q: string) => {
  return await api.get(`/items/dropdownbysearch/${q}`);
};

/*Delete Item */
export const deleteItems = async (dto: DeletItemsDto) => {
  return await api.delete(`/items/${dto.id}`);
};

/*fill Item by id*/
export const getItemsById = async (itemsId: string | undefined) => {
  return await api.get(`/items/${itemsId}`);
};

/*Create Item */
export const createItems = async (itemsDetails: ItemsType) => {

  const getToken = () => {
    return localStorage.getItem('accessToken');
  };

  const formData = new FormData();

  for (const key in itemsDetails) {
    if (Object.prototype.hasOwnProperty.call(itemsDetails, key)) {
      // @ts-ignore
      const value = itemsDetails[key];
      const sanitizedValue =
        typeof value === "boolean" ? value.toString() : value || "";

      formData.append(key, sanitizedValue);
    }
  }

  try {
    const response = await axios.post((window as any).REACT_APP_BASE_API_URL + "/items", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

/*Edit Item */
export const editItems = async (itemsId: any, itemsDetails: ItemsType) => {
  const getToken = () => {
    return localStorage.getItem('accessToken');
  };

  const formData = new FormData();

  for (const key in itemsDetails) {
    if (Object.prototype.hasOwnProperty.call(itemsDetails, key)) {
      // @ts-ignore
      const value = itemsDetails[key];
      const sanitizedValue =
        typeof value === "boolean" ? value.toString() : value || "";

      formData.append(key, sanitizedValue);
    }
  }

  try {
    const response = await axios.put((window as any).REACT_APP_BASE_API_URL + `/items/${itemsId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

/*get item name by Id for Packaging & modifier & component */
export const getItemsBy = async (itemsId: string | undefined) => {
  const response = await api.get(`/items/${itemsId}`);
  return response.data.name; // return only the name of the item
};

/*Search filter packaging*/
export const getItemsId = async (body: {
  itemsId: string | undefined;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/items/${body.itemsId}?q=${body.q.toString()}`;
  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

/*Item search filter */
export const getItemsApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
  isChild: boolean;
}) => {
  let url = `/items?limit=${body.limit}&q=${body.q.toString()}&isChild=${body.isChild
    }`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

/*packaging modal api */
export const editPackaging = async (itemid: any, body: ItemsType) => {
  return await api.put(`/items/${itemid}/pack-item`, body);
};

/*Delete Child Item */
export const deleteChildItem = async (dto: DeletItemsDto) => {
  return await api.delete(`/items/child-item/${dto.id}`);
};

/*compose modal api */
export const editCompose = async (itemid: any, body: ItemsType) => {
  return await api.put(`/items/${itemid}/compose-item`, body);
};
export const getItemsByCategory = async (categoryId: string | undefined) => {
  return await api.get(`/items/categories/${categoryId}`);
};
